import React, { useState } from "react";

function AdminLogin({ api, onAuthenticated }) {
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setError("");
    try {
      const session = await api.login(password);
      setPassword("");
      onAuthenticated(session);
    } catch (requestError) {
      setPassword("");
      setError(requestError?.message || "Sign in failed. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="adminLogin" onSubmit={submit}>
      <p className="adminLoginIntro">Confirm your enrolled administrator account with its password.</p>
      {error && <div className="adminAlert adminAlertError" role="alert">{error}</div>}
      <label htmlFor="admin-password">Password</label>
      <input
        id="admin-password"
        name="password"
        type="password"
        autoComplete="current-password"
        value={password}
        onChange={(event) => setPassword(event.target.value)}
        data-admin-initial-focus="true"
        required
      />
      <button className="adminPrimaryButton" type="submit" disabled={submitting}>
        {submitting ? "Signing in…" : "Sign in"}
      </button>
    </form>
  );
}

export default AdminLogin;
